/** Default routes */
import { CREATE_ROUTE, EDIT_ROUTE, ID_ROUTE, PREVIEW_ROUTE } from '@core/constants/navigation/navigation-params.const';

/** Home */
export const HOME_ROUTE = '/';

/** Error pages routes */
export const ERROR_PAGES_ROUTE_MODULE = 'strona-bledu';
export const ERROR_PAGES_ROUTE = `/${ERROR_PAGES_ROUTE_MODULE}`;
export const ERROR_PAGES_404_PAGE = '404';
export const ERROR_PAGES_404_ROUTE = `${ERROR_PAGES_ROUTE}/${ERROR_PAGES_404_PAGE}`;

/** Authorization routes */
export const LOGIN_ROUTE_MODULE = 'logowanie';
export const LOGIN_ROUTE = `/${LOGIN_ROUTE_MODULE}`;

/** Forms routes */
export const CORRECTION_FORM_MODULE = 'formularz-korygujacy';
export const CORRECTION_FORM_ROUTE = `/${CORRECTION_FORM_MODULE}`;
export const CORRECTION_FORM__ROUTE_PART__NON_CONFORMITY = 'niezgodnosci';
export const CORRECTION_FORM__ROUTE__NON_CONFORMITY = `${CORRECTION_FORM_ROUTE}/niezgodnosci`;

/** Admin routes */
// DASHBOARD
export const DASHBOARD_ROUTE_MODULE = 'dashboard';
export const DASHBOARD_ROUTE = `/${DASHBOARD_ROUTE_MODULE}`;

// USTAWIENIA
export const SETTINGS_ROUTE_MODULE = 'ustawienia';
export const SETTINGS_ACCOUNT_ROUTE_SECTION = 'konto';
export const SETTINGS_COMPANIES_ROUTE_SECTION = 'firmy';
export const SETTINGS_USERS_ROUTE_SECTION = 'audytorzy';
export const SETTINGS_ORGANIZATIONAL_UNITS_SECTION = 'jednostki-organizacyjne';
export const SETTINGS_STANDARDS_TYPES_SECTION = 'typy-standardow';
export const SETTINGS_STANDARDS_SECTION = 'standardy';
export const SETTINGS_ROUTE = `/${SETTINGS_ROUTE_MODULE}`;

// USTAWIENIA - KONTO
export const SETTINGS_ACCOUNT_ROUTE = `${SETTINGS_ROUTE}/${SETTINGS_ACCOUNT_ROUTE_SECTION}`;

// USTAWIENIA - FIRMY
export const SETTINGS_COMPANIES_ROUTE = `${SETTINGS_ROUTE}/${SETTINGS_COMPANIES_ROUTE_SECTION}`;
export const SETTINGS_COMPANIES_ROUTE_CREATE = `${SETTINGS_COMPANIES_ROUTE}/${CREATE_ROUTE}`;
export const SETTINGS_COMPANIES_ROUTE_EDIT = `${SETTINGS_COMPANIES_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

// USTAWIENIA - UŻYTKOWNICY (AUDYTORZY)
export const SETTINGS_USERS_ROUTE = `${SETTINGS_ROUTE}/${SETTINGS_USERS_ROUTE_SECTION}`;
export const SETTINGS_USERS_ROUTE_CREATE = `${SETTINGS_USERS_ROUTE}/${CREATE_ROUTE}`;
export const SETTINGS_USERS_ROUTE_EDIT = `${SETTINGS_USERS_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

// USTAWIENIA - JEDNOSTKI ORGANIZACYJNE
export const SETTINGS_ORGANIZATIONAL_UNITS_ROUTE = `${SETTINGS_ROUTE}/${SETTINGS_ORGANIZATIONAL_UNITS_SECTION}`;
export const SETTINGS_ORGANIZATIONAL_UNITS_ROUTE_CREATE = `${SETTINGS_ORGANIZATIONAL_UNITS_ROUTE}/${CREATE_ROUTE}`;
export const SETTINGS_ORGANIZATIONAL_UNITS_ROUTE_EDIT = `${SETTINGS_ORGANIZATIONAL_UNITS_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

// USTAWIENIA - TYPY STANDARDOW
export const SETTINGS_STANDARDS_TYPES_ROUTE = `${SETTINGS_ROUTE}/${SETTINGS_STANDARDS_TYPES_SECTION}`;
export const SETTINGS_STANDARDS_TYPES_ROUTE_CREATE = `${SETTINGS_STANDARDS_TYPES_ROUTE}/${CREATE_ROUTE}`;
export const SETTINGS_STANDARDS_TYPES_ROUTE_EDIT = `${SETTINGS_STANDARDS_TYPES_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

// USTAWIENIA - STANDARDY
export const SETTINGS_STANDARDS_ROUTE = `${SETTINGS_ROUTE}/${SETTINGS_STANDARDS_SECTION}`;
export const SETTINGS_STANDARDS_ROUTE_CREATE = `${SETTINGS_STANDARDS_ROUTE}/${CREATE_ROUTE}`;
export const SETTINGS_STANDARDS_ROUTE_EDIT = `${SETTINGS_STANDARDS_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

// SUBSKRYPCJE
export const SUBSCRIPTIONS_ROUTE_MODULE = SETTINGS_ROUTE_MODULE;
export const SUBSCRIPTIONS__SUBSCRIPTION_SECTION = 'subskrypcje';
export const SUBSCRIPTIONS__LICENSE_SECTION = 'licencja';

export const SUBSCRIPTIONS__SUBSCRIPTION_ROUTE = `/${SUBSCRIPTIONS_ROUTE_MODULE}/${SUBSCRIPTIONS__SUBSCRIPTION_SECTION}`;
export const SUBSCRIPTIONS__SUBSCRIPTION_ROUTE_CREATE = `${SUBSCRIPTIONS__SUBSCRIPTION_ROUTE}/${CREATE_ROUTE}`;
export const SUBSCRIPTIONS__SUBSCRIPTION_ROUTE_EDIT = `${SUBSCRIPTIONS__SUBSCRIPTION_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

export const SUBSCRIPTIONS__LICENSE_ROUTE = `/${SUBSCRIPTIONS_ROUTE_MODULE}/${SUBSCRIPTIONS__LICENSE_SECTION}`;

// MARK
export const MARK_ROUTE_MODULE = 'nowa-ocena';
export const MARK_ROUTE = `/${MARK_ROUTE_MODULE}`;

// AUDITS
export const AUDIT_ROUTE_MODULE = 'audyt';
export const AUDIT_ROUTE_FINISHED_PAGE = 'zakonczony';
export const AUDIT_ROUTE_EXECUTION_PAGE = 'realizacja';
export const AUDIT_ROUTE = `/${AUDIT_ROUTE_MODULE}`;
export const AUDIT_ROUTE_CREATE = `${AUDIT_ROUTE}/${CREATE_ROUTE}`;
export const AUDIT_ROUTE_EDIT = `${AUDIT_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;
export const AUDIT_ROUTE_PREVIEW = `${AUDIT_ROUTE}/${PREVIEW_ROUTE}/${ID_ROUTE}`;
export const AUDIT_ROUTE_PREVIEW_FINISHED = `${AUDIT_ROUTE}/${PREVIEW_ROUTE}/${ID_ROUTE}/${AUDIT_ROUTE_FINISHED_PAGE}`;
export const AUDIT_ROUTE_EXECUTION = `${AUDIT_ROUTE}/${AUDIT_ROUTE_EXECUTION_PAGE}/${ID_ROUTE}`;

// CRM (Wiadomości)
export const MESSAGES_ROUTE_MODULE = 'wiadomosci';
export const MESSAGES_ROUTE = `/${MESSAGES_ROUTE_MODULE}`;
export const MESSAGES_SEND_ROUTE_SECTION = 'wyslij';
export const MESSAGES_SEND_ROUTE = `${MESSAGES_ROUTE}/${MESSAGES_SEND_ROUTE_SECTION}`;
export const MESSAGES_PREVIEW_ROUTE = `${MESSAGES_ROUTE}/${PREVIEW_ROUTE}/${ID_ROUTE}`;

// NON-CONFORMITIES
export const NON_CONFORMITIES_ROUTE_MODULE = 'niezgodnosci';
export const NON_CONFORMITIES_ROUTE = `/${NON_CONFORMITIES_ROUTE_MODULE}`;
export const NON_CONFORMITIES_ROUTE_EDIT = `${NON_CONFORMITIES_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

// SUPPLIERS
export const SUPPLIER_ROUTE_MODULE = 'dostawcy';
export const SUPPLIER_ROUTE = `/${SUPPLIER_ROUTE_MODULE}`;
export const SUPPLIER_ROUTE_CREATE = `${SUPPLIER_ROUTE}/${CREATE_ROUTE}`;
export const SUPPLIER_ROUTE_EDIT = `${SUPPLIER_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

export const SUPPLIER__RATING_QUALIFICATION_PAGE = 'ocena-i-kwalifikacja-dostawcy';
export const SUPPLIER__RATING_QUALIFICATION_ID_PARAM = 'qualificationId';
export const SUPPLIER__RATING_QUALIFICATION_ID_ROUTE_PARAM = `:${SUPPLIER__RATING_QUALIFICATION_ID_PARAM}`;
export const SUPPLIER__RATING_QUALIFICATION_CREATE_ROUTE = `${SUPPLIER_ROUTE}/${ID_ROUTE}/${SUPPLIER__RATING_QUALIFICATION_PAGE}`;
export const SUPPLIER__RATING_QUALIFICATION_EDIT_ROUTE = `${SUPPLIER_ROUTE}/${ID_ROUTE}/${SUPPLIER__RATING_QUALIFICATION_PAGE}/${SUPPLIER__RATING_QUALIFICATION_ID_ROUTE_PARAM}`;

// MATERIALS
export const MATERIAL_ROUTE_MODULE = 'surowce';
export const MATERIAL_ROUTE = `/${MATERIAL_ROUTE_MODULE}`;
export const MATERIAL_ROUTE_CREATE = `${MATERIAL_ROUTE}/${CREATE_ROUTE}`;
export const MATERIAL_ROUTE_EDIT = `${MATERIAL_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;

export const MATERIAL__FRAUD_RISK_RATING_PAGE = 'ocena-ryzyka-zafalszowan-surowca';
export const MATERIAL__FRAUD_RISK_RATING_ID_PARAM = 'globalRiskAssessmentId';
export const MATERIAL__FRAUD_RISK_RATING_ID_ROUTE_PARAM = `:${MATERIAL__FRAUD_RISK_RATING_ID_PARAM}`;
export const MATERIAL__FRAUD_RISK_RATING_ROUTE_CREATE = `${MATERIAL_ROUTE}/${ID_ROUTE}/${MATERIAL__FRAUD_RISK_RATING_PAGE}`;
export const MATERIAL__FRAUD_RISK_RATING_ROUTE_EDIT = `${MATERIAL_ROUTE}/${ID_ROUTE}/${MATERIAL__FRAUD_RISK_RATING_PAGE}/${MATERIAL__FRAUD_RISK_RATING_ID_ROUTE_PARAM}`;

export const MATERIAL__GENERAL_RISK_RATING_PAGE = 'ocena-ryzyka-surowca';
export const MATERIAL__GENERAL_RISK_RATING_ID_PARAM = 'riskAssessmentId';
export const MATERIAL__GENERAL_RISK_RATING_ID_ROUTE_PARAM = `:${MATERIAL__GENERAL_RISK_RATING_ID_PARAM}`;
export const MATERIAL__GENERAL_RISK_RATING_CREATE_ROUTE = `${MATERIAL_ROUTE}/${ID_ROUTE}/${MATERIAL__FRAUD_RISK_RATING_ID_ROUTE_PARAM}/${MATERIAL__GENERAL_RISK_RATING_PAGE}`;
export const MATERIAL__GENERAL_RISK_RATING_EDIT_ROUTE = `${MATERIAL_ROUTE}/${ID_ROUTE}/${MATERIAL__GENERAL_RISK_RATING_PAGE}/${MATERIAL__GENERAL_RISK_RATING_ID_ROUTE_PARAM}`;

// DICTIONARIES
export const DICTIONARY_ROUTE_MODULE = 'slowniki';
export const DICTIONARY_ROUTE = `/${DICTIONARY_ROUTE_MODULE}`;
export const DICTIONARY_ROUTE_CREATE = `${DICTIONARY_ROUTE}/${CREATE_ROUTE}`;
export const DICTIONARY_ROUTE_EDIT = `${DICTIONARY_ROUTE}/${EDIT_ROUTE}/${ID_ROUTE}`;
